import React from "react";
import "./Loading.scss";

export default function Loading() {
  return (
    <div className="folding-cube">
      <div className="cube1 cube"></div>
      <div className="cube2 cube"></div>
      <div className="cube4 cube"></div>
      <div className="cube3 cube"></div>
    </div>
  );
}
